module.exports = __webpack_public_path__ + "img/reward-money-dark.f9391c2f.png";